module.exports = __webpack_public_path__ + "img/20.012006c2.jpg";